<template>
    <div style="height:100%">
        <div class="jsc-content">
            <!-- 左 -->
            <div class="jscLeft">
                <!-- 第一个 -->
                <div style="width:100%">
                    <div style="color:#fff;font-weight: 600;">预警中心</div>
                    <div class="line-content"> <div class="line1"></div><div class="line2"></div></div>
                    <div>
                        <div class="jdzh">
                            <div class="jdzh-left" style="background-color: #460b0c;color: #fd3f3f;">
                                <span>进度滞后</span>
                            </div>
                            <div class="jdzh-right">
                                <div  class="jdzh-right-item"><span>现场进度滞后</span><span class="jdzh-right-sz">
                                    <!-- <tpscrollNumber ref="scrollNumber" :value="serveData.x1"></tpscrollNumber> -->
                                     <tpscrollNumber ref="scrollNumber" :value="'2'"></tpscrollNumber>
                                    </span></div>
                                <div  class="jdzh-right-item"><span>计量进度滞后</span><span  class="jdzh-right-sz">
                                    <!-- <tpscrollNumber ref="scrollNumber" :value="serveData.x2"></tpscrollNumber> -->
                                     <tpscrollNumber ref="scrollNumber" :value="'3'"></tpscrollNumber>
                                    </span></div>
                                <div class="jdzh-right-item"><span>支付进度滞后</span><span class="jdzh-right-sz">
                                    <!-- <tpscrollNumber ref="scrollNumber" :value="serveData.x3"></tpscrollNumber> -->
                                     <tpscrollNumber ref="scrollNumber" :value="'1'"></tpscrollNumber>
                                    </span></div>
                                <div  class="jdzh-right-item"><span>试验进度滞后</span><span  class="jdzh-right-sz">
                                    <!-- <tpscrollNumber ref="scrollNumber" :value="serveData.x4"></tpscrollNumber> -->
                                     <tpscrollNumber ref="scrollNumber" :value="'2'"></tpscrollNumber>
                                    </span></div>
                                <div class="jdzh-right-item"><span>检验评定滞后</span><span class="jdzh-right-sz">
                                    <!-- <tpscrollNumber ref="scrollNumber" :value="serveData.x5"></tpscrollNumber> -->
                                     <tpscrollNumber ref="scrollNumber" :value="'5'"></tpscrollNumber>
                                    </span></div>
                            </div>
                        </div>
                        <div class="jdzh">
                            <div class="jdzh-left" style="background-color: rgb(83,58,39);color: rgb(224,157,86);">
                                <span>超期未整改</span>
                            </div>
                            <div class="jdzh-right">
                                <div class="cq-right-item"><span>重大质量问题超期未整改</span><span class="jdzh-right-sz">
                                     <!-- <tpscrollNumber ref="scrollNumber" :value="serveData1.x1"></tpscrollNumber> -->
                                     <tpscrollNumber ref="scrollNumber" :value="'3'"></tpscrollNumber>
                                    </span></div>
                                <div class="cq-right-item"><span>重大安全问题超期未整改</span><span  class="jdzh-right-sz">
                                     <!-- <tpscrollNumber ref="scrollNumber" :value="serveData1.x2"></tpscrollNumber> -->
                                     <tpscrollNumber ref="scrollNumber" :value="'4'"></tpscrollNumber>
                                    </span></div>
                            </div>
                        </div>
                        <div class="jdzh">
                            <div class="jdzh-left"  style="background-color: rgb(30,10,88);color: rgb(201,205,255);">
                                <span>隐患消号</span>
                            </div>
                            <div class="jdzh-right">
                                <div class="yh-right-item"><span>重大安全隐患</span><span class="jdzh-right-sz">
                                     <!-- <tpscrollNumber ref="scrollNumber" :value="serveData2.x1"></tpscrollNumber> -->
                                     <tpscrollNumber ref="scrollNumber" :value="'2'"></tpscrollNumber>
                                    </span></div>
                                <div class="yh-right-item"><span>一安全般隐患</span><span  class="jdzh-right-sz">
                                     <!-- <tpscrollNumber ref="scrollNumber" :value="serveData2.x2"></tpscrollNumber> -->
                                     <tpscrollNumber ref="scrollNumber" :value="'0'"></tpscrollNumber>
                                    </span></div>
                            </div>
                        </div>
                        <div class="jdzh">
                            <div class="jdzh-left"  style="background-color: rgb(7,53,77);color: rgb(156,219,236);">
                                <span class="dbBtn">督办事项<i @click="goDbMentd()" class="el-icon-circle-plus-outline"></i></span>
                            </div>
                            <div class="jdzh-right">
                                <div class="db-right-item">
                                    <span @click="goDbMentd()" style="text-decoration: underline;cursor: pointer;">督办</span>
                                    <span class="jdzh-right-sz" style="border: 2px solid rgb(168,238,251);border-radius: 5px;cursor: pointer;">
                                     <!-- <tpscrollNumber ref="scrollNumber" :value="serveData3.x1"></tpscrollNumber> -->
                                     <tpscrollNumber ref="scrollNumber" :value="'4'"></tpscrollNumber>
                                    </span></div>
                                <div class="db-right-item"><span>进行中</span>
                                <span  class="jdzh-right-sz"  style="border: 2px solid rgb(168,238,251);border-radius: 5px;cursor: pointer;" >
                                     <!-- <tpscrollNumber ref="scrollNumber" :value="serveData3.x2"></tpscrollNumber> -->
                                     <tpscrollNumber ref="scrollNumber" :value="'2'"></tpscrollNumber>
                                    </span></div>
                                <div class="db-right-item"><span>已完成</span>
                                <span  class="jdzh-right-sz" style="border: 2px solid rgb(168,238,251);border-radius: 5px;cursor: pointer;">
                                     <!-- <tpscrollNumber ref="scrollNumber" :value="serveData3.x3"></tpscrollNumber> -->
                                     <tpscrollNumber ref="scrollNumber" :value="'2'"></tpscrollNumber>
                                    </span></div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <!-- 左上第一个 -->
                <div style="width:100%;height:39%">
                    <!-- <div style="color:#fff">生产动态</div>
                    <div class="line-content"> <div class="line1"></div><div class="line2"></div></div> -->
                    <div class="majorEvents-List">
                           <div class="majorEvents-item-title">
                               <div>序号</div>
                               <div style="position:relative;left:-28px">预警事件</div>
                               <div>时间</div>
                               <div>单位工程</div>
                           </div>
                        <div style="padding-right:5px" :class="{ anim: animate == true }" @mouseover="mouseOver"
                            @mouseout="mouseOut">
                        <div @click="getmajorEventInfo(i)" :class="['majorEvents-item',index%2!= 1?'itemActive':'']" class="majorEvents-item" v-for="(i,index) in scdtList">
                            <div>{{i.xh}}</div>
                            <div :style="{'width':'100px',color:i.color}">{{i.title}}</div>
                            <div style="color:rgb(128,138,148)">{{i.time}}</div>
                            <div style="width:100px;color:#d0d0d0">{{ i.pr }}</div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 中 -->
            <div class="jscMiddle">
                <div class="jscMiddle-topContent" style="text-align: center;margin-top:20px;width:100%">
                    <!-- <div style="width:30%">
                        <DashboardLeft></DashboardLeft>
                    </div>
                    <div style="width:30%">
                        <DashboardMiddle></DashboardMiddle>
                    </div>
                    <div style="width:30%">
                        <dashboardRight></dashboardRight>
                    </div> -->
                    <img :src="require('../../assets/cockpitCh/ybp.png')">
                </div>
                <div   style="text-align: center;margin-top:20px">
                    <el-popover
                    popper-class="popperStyle"
                        placement="top"
                        width="300"
                        trigger="hover">
                        <div style="width:100%">
                            <img  style="width:100%" :src="require('../../assets/cockpitCh/lineTioop.png')">
                        </div>
                         <img  slot="reference" :src="require('../../assets/cockpitCh/lineEchart.png')">
                        </el-popover>
                </div>
                <!-- <div   style="text-align: center;margin-top:20px;position: relative;">
                    <div style="text-align: left; margin-left: 7%;position: absolute;">
                         <el-radio-group class="radioGroupStyle" size="mini" v-model="radio1">
                            <el-radio-button label="年"></el-radio-button>
                            <el-radio-button label="月"></el-radio-button>
                            <el-radio-button label="周"></el-radio-button>
                            </el-radio-group>                      
                    </div>
                    <echartDiagram></echartDiagram>
                </div> -->
                <div  style="text-align: center;margin-top:23px">
                    <img :src="require('../../assets/cockpitCh/middleTable.png')">
                </div>

            </div>
            <!-- 右 -->
            <div class="jscRight">
                <!-- 第一个 -->
                <div style="width:100%">
                    <div style="color:#fff;font-weight: 600;">成本分布</div>
                    <div class="line-content"> <div class="line1"></div><div class="line2"></div></div>
                    <div class="cbfb-content">
                        <img :src="require('../../assets/cockpitCh/bt1.png')">
                        <div style="width:91%;height:134px" id="Homebarleft"></div>
                    </div>

                </div>
                <div>
                     <!-- 第二个 -->
                <div style="width:100%;margin-top:29px">
                    <div style="color:#fff;margin-top:10px;font-weight: 600;">征地拆迁</div>
                    <div class="line-content"> <div class="line1"></div><div class="line2"></div></div>
                    <div class="cbfb-content">
                        <div style="width:100%;height:130px" id="Homebarleftzd"></div>
                    </div>

                </div>
                   <!-- 第三个 -->
                <div style="width:100%;margin-top:27px">
                    <div style="color:#fff;margin-top:10px;font-weight: 600;">重点工程</div>
                    <div class="line-content"> <div class="line1"></div><div class="line2"></div></div>
                    <div class="zdgcBg">
                        <img class="zdgcBgImg" :src="require('../../assets/cockpitCh/zdgcBg.png')">
                        <el-carousel trigger="click" height="100%" :interval="5000" arrow="always" style="width:100%;height: 100%;">
                            <el-carousel-item v-for="item in imgList" :key="item.name">
                            <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" :title="item.title"/>
                            </el-carousel-item>
                        </el-carousel> 
                    </div>

                </div>
                </div>
            </div>            
        </div>
    </div>
</template>
<script>
import tpscrollNumber from './tpscrollNumber.vue'
import DashboardMiddle from './echarts/DashboardMiddle.vue'
import DashboardLeft from './echarts/DashboardLeft.vue'
import DashboardRight from './echarts/DashboardRight.vue'

import echartDiagram from './echarts/echartDiagram.vue'
export default {
    components:{
        tpscrollNumber,DashboardMiddle,DashboardLeft,DashboardRight,echartDiagram
    },
    data(){
        return{
            radio1:'月',
            animate: false,
            timer: null,
            scdtList:[
                {xh:'1',title:'进度滞后预警',time:'2022-03-19',pr:'老里箐隧道右幅K2+123~K2+k139',color:'rgb(201,144,148)'},
                {xh:'2',title:'重大质量问题超期未整改',time:'2022-03-19',pr:'老里箐隧道右幅K2+123~K2+k139',color:'rgb(153,104,12)'},
                {xh:'3',title:'进度滞后预警',time:'2022-03-19',pr:'老里箐隧道右幅K2+123~K2+k139',color:'rgb(201,144,148)'},
                {xh:'4',title:'进度滞后预警',time:'2022-03-19',pr:'老里箐隧道右幅K2+123~K2+k139',color:'rgb(201,144,148)'},
                {xh:'5',title:'重大安全隐患',time:'2022-03-19',pr:'老里箐隧道右幅K2+123~K2+k139',color:'rgb(142,158,206)'},
                {xh:'6',title:'进度滞后预警',time:'2022-03-19',pr:'老里箐隧道右幅K2+123~K2+k139',color:'rgb(201,144,148)'},
                {xh:'7',title:'进度滞后预警',time:'2022-03-19',pr:'老里箐隧道右幅K2+123~K2+k139',color:'rgb(201,144,148)'},
                {xh:'8',title:'进度滞后预警',time:'2022-03-19',pr:'老里箐隧道右幅K2+123~K2+k139',color:'rgb(201,144,148)'},
                {xh:'9',title:'进度滞后预警',time:'2022-03-19',pr:'老里箐隧道右幅K2+123~K2+k139',color:'rgb(201,144,148)'},
            ],
            serveDataTimer:null,
            serveDataTimer1:null,
            serveDataTimer2:null,
            serveDataTimer3:null,
            serveDataCopy:{
               x1:2,
               x2:3,
               x3:1,
               x4:2,
               x5:5,
            },
           serveData:{
               x1:0,
               x2:0,
               x3:0,
               x4:0,
               x5:0,
           },
           serveData1Copy:{
               x1:3,
               x2:4,
           },
           serveData1:{
               x1:0,
               x2:0,

           },
           serveData2Copy:{
               x1:2,
               x2:0,
           },
           serveData2:{
               x1:0,
               x2:0,

           },
            serveData3Copy:{
               x1:3,
               x2:2,
               x3:2,
           },
           serveData3:{
               x1:0,
               x2:0,
               x3:0,

           },
           imgList:[
               {src:require('../../assets/cockpitCh/1.png')},
               {src:require('../../assets/cockpitCh/2.png')},
               {src:require('../../assets/cockpitCh/3.png')},
               {src:require('../../assets/cockpitCh/4.png')},
               ]

        }
    },
    mounted(){
        this.timer = setInterval(this.scroll, 2000);
        // this.serveDataTimer = setInterval(this.serveDatascroll, 2000);
        //  this.serveDataTimer1 = setInterval(this.serveDatascroll1, 2000);
        //   this.serveDataTimer2 = setInterval(this.serveDatascroll2, 2000);
        //    this.serveDataTimer3 = setInterval(this.serveDatascroll3, 2000);
        this.zzt()
        this.zdc1()
        this.getlineEchart()
    },
    methods:{
        goDbMentd(){
            window.open('/supervisionNotice/taskList')
        },
        getlineEchart(){
      let that = this;
      var myChart = that.$echarts.init(document.getElementById('lineEchart'));
      let option = {
				color: ["rgb(213,182,76)","rgb(40,106,248)"],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow",
					},
					textStyle: {
						fontSize: 12,
					},
				},
				legend: {
                    // show:false,
					icon: "circle",
					itemWidth: 20,
					itemHeight: 10,
                    textStyle: {
						fontSize: 12,
						color: "#fff",
						fontWeight: "normal",
					},
				},
				title: {
					// text: "试验室总体情况",
					top: "3%",
					textStyle: {
						fontSize: 14,
						color: "#333333",
						fontWeight: "normal",
					},
				},
				grid: {
					left: "5%",
					right: "5%",
					top: "20%",
					bottom: "5%",
					containLabel: true,
				},
				xAxis: {
					type: "category",
					data: ["用地", "拆迁", "水保",'其它'],
                    axisLabel:{
                        textStyle:{
                            color:'#fff',
                            fontSize:12
                        },
                        lineStyle:{
                            color:'#000'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#000"
                        }
                        },
				},
				yAxis: {
					type: "value",
					// name: "单位(组)",
					axisLabel: {
						show: true,
						formatter: "{value}",
                        textStyle:{
                            color:'#fff',
                            fontSize:12
                        }
					},
                           splitLine: {
                        show:true,
                        lineStyle: {
                            color: "#575757"
                        }
                        },
                    axisLine:{
                        lineStyle:{
                            color:'#333'
                        }
                    },
					nameTextStyle: {
						align: "right",
					},
				},
				series: [
					{
						name: "征拆费用(万元)",
						data: [1, 2, 3,4],
						type: "line",
						// barWidth: 15,
					},
					{
						name: "征拆进度(%)",
						data: [6, 7, 8,9],
						type: "line",
						// barWidth: 15,
					}
				],
			};;
      option && myChart.setOption(option);
      window.onresize = function(){
        myChart.resize();
      }
    },
        zdc1(){
      let that = this;
      var myChart = that.$echarts.init(document.getElementById('Homebarleftzd'));
      let option = {
				color: ["rgb(213,182,76)","rgb(40,106,248)"],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow",
					},
					textStyle: {
						fontSize: 12,
					},
				},
				legend: {
                    // show:false,
					icon: "circle",
					itemWidth: 20,
					itemHeight: 10,
                    textStyle: {
						fontSize: 12,
						color: "#fff",
						fontWeight: "normal",
					},
				},
				title: {
					// text: "试验室总体情况",
					top: "3%",
					textStyle: {
						fontSize: 14,
						color: "#333333",
						fontWeight: "normal",
					},
				},
				grid: {
					left: "5%",
					right: "5%",
					top: "20%",
					bottom: "5%",
					containLabel: true,
				},
				xAxis: {
					type: "category",
					data: ["用地", "拆迁", "水保",'其它'],
                    axisLabel:{
                        textStyle:{
                            color:'#fff',
                            fontSize:12
                        },
                        lineStyle:{
                            color:'#000'
                        }
                    },
                    // splitLine: {
                    //     show:true,
                    //     lineStyle: {
                    //         color: "#575757"
                    //     }
                    //     },
				},
                yAxis: [
                        {
                        type: 'value',
                        name: '',
                        position: 'left',
                        alignTicks: true,
                        minInterval: 1,
                        axisLine: {
                            show: true,
                            lineStyle: {
                            color: 'rgb(213,182,76)'
                            }
                        },
                        axisLabel: {
                            formatter: '{value}'
                        },
                         splitLine: {
                        show:true,
                        lineStyle: {
                            color: "#575757"
                        }
                        },
                        },
                        {
                        type: 'value',
                        name: '',
                        position: 'right',
                        alignTicks: true,
                        minInterval: 1,
                        axisLine: {
                            show: true,
                            lineStyle: {
                            color: 'rgb(40,106,248)'
                            }
                        },
                        axisLabel: {
                            formatter: '{value}%'
                        },
                         splitLine: {
                        show:false,
                        lineStyle: {
                            color: "#575757"
                        }
                        },
                        }
                    ],
				// yAxis: {
				// 	type: "value",
				// 	// name: "单位(组)",
				// 	axisLabel: {
				// 		show: true,
				// 		formatter: "{value}",
                //         textStyle:{
                //             color:'#fff',
                //             fontSize:12
                //         }
				// 	},
                //        splitLine: {
                //         show:true,
                //         lineStyle: {
                //             color: "#575757"
                //         }
                //         },
                    
                //         // axisLine: {
                //         // show:true,//是否显示轴线
                //         // lineStyle: {
                //         //     color: '#575757',//刻度线的颜色
                //         // }
                //         // },
				// 	nameTextStyle: {
				// 		align: "right",
				// 	},
				// },
				series: [
					{
						name: "征拆费用(万元)",
						data: [530, 500, 300,100],
						type: "bar",
						barWidth: 15,
					},
					{
						name: "征拆进度(%)",
                        yAxisIndex: 1,
						data: [50, 22, 18,17],
						type: "bar",
						barWidth: 15,
					}
				],
			};;
      option && myChart.setOption(option);
      window.onresize = function(){
        myChart.resize();
      }
    },
       zzt(){
      let that = this;
      var myChart = that.$echarts.init(document.getElementById('Homebarleft'));
      let option = {
				color: ["rgb(32,79,200)","rgb(87,223,208)","rgb(78,193,98)","rgb(233,179,77)","rgb(198,203,192)"],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow",
					},
					textStyle: {
						fontSize: 12,
					},
				},
				legend: {
                    show:false,
					icon: "circle",
					itemWidth: 20,
					itemHeight: 10,
				},
				title: {
					// text: "试验室总体情况",
					top: "3%",
					textStyle: {
						fontSize: 14,
						color: "#333333",
						fontWeight: "normal",
					},
				},
				grid: {
					left: "5%",
					right: "5%",
					top: "20%",
					bottom: "5%",
					containLabel: true,
				},
				xAxis: {
					type: "category",
					data: ["1月", "2月", "3月",'4月','5月','6月'],
                    axisLabel:{
                        textStyle:{
                            color:'#fff',
                            fontSize:12
                        }
                    },
                    axisLine:{
                        lineStyle:{
                            color:'#333'
                        }
                    }
				},
				yAxis: {
					type: "value",
					// name: "单位(组)",
					axisLabel: {
						show: true,
						formatter: "{value}",
                        textStyle:{
                            color:'#fff',
                            fontSize:12
                        }
					},
                           splitLine: {
                        show:true,
                        lineStyle: {
                            color: "#575757"
                        }
                        },
                    axisLine:{
                        lineStyle:{
                            color:'#333'
                        }
                    },
					nameTextStyle: {
						align: "right",
					},
				},
				series: [
					{
						name: "工程款",
						data: [100, 150, 400,650.3,800.1,964.36],
						// data:that.bar_data2[0],
						type: "bar",
						barWidth: 8,
					},
					{
						name: "管理费",
						data: [80, 200, 320,450,600,735.36],
						// data:that.bar_data2[1],
						type: "bar",
						barWidth: 8,
					},
					{
						name: "监理费",
						data: [100, 200, 220,340,500,636.37],
						// data:that.bar_data2[2],
						type: "bar",
						barWidth: 8,
					},
                    {
						name: "前期款",
						data: [22, 50, 70,100,150,234.56],
						// data:that.bar_data2[2],
						type: "bar",
						barWidth: 8,
					},
                    {
						name: "其他费用",
						data: [10, 21, 30,45,60,88.26],
						// data:that.bar_data2[2],
						type: "bar",
						barWidth: 8,
					},
				],
			};;
      option && myChart.setOption(option);
      window.onresize = function(){
        myChart.resize();
      }
    },
        serveDatascroll(){
      setTimeout(() => {
          if(this.serveData.x1<=this.serveDataCopy.x1){
           this.serveData.x1=this.serveData.x1+1
          }else{
              this.serveData.x1=0
          }

          if(this.serveData.x2<=this.serveDataCopy.x2){
          this.serveData.x2=this.serveData.x2+1
          }else{
              this.serveData.x2=0
          }
          if(this.serveData.x3<=this.serveDataCopy.x3){
          this.serveData.x3+=1
          }else{
              this.serveData.x3=0
          }
          if(this.serveData.x4<=this.serveDataCopy.x4){
          this.serveData.x4+=1
          }else{
              this.serveData.x4=0
          }
          if(this.serveData.x5<=this.serveDataCopy.x5){
          this.serveData.x5+=1
          }else{
              this.serveData.x5=0
          }
      }, 3000);
        },
        serveDatascroll1(){
      setTimeout(() => {
          if(this.serveData1.x1<=this.serveData1Copy.x1){
           this.serveData1.x1=this.serveData1.x1+1
          }else{
              this.serveData1.x1=0
          }

          if(this.serveData1.x2<=this.serveData1Copy.x2){
          this.serveData1.x2=this.serveData1.x2+1
          }else{
              this.serveData.x2=0
          }
      }, 3000);
        },
        serveDatascroll2(){
      setTimeout(() => {
          if(this.serveData2.x1<=this.serveData2Copy.x1){
           this.serveData2.x1=this.serveData2.x1+1
          }else{
              this.serveData2.x1=0
          }

          if(this.serveData2.x2<=this.serveData2Copy.x2){
          this.serveData2.x2=this.serveData2.x2+1
          }else{
              this.serveData2.x2=0
          }
      }, 3000);
        },
                serveDatascroll3(){
      setTimeout(() => {
          if(this.serveData3.x1<=this.serveData3Copy.x1){
           this.serveData3.x1=this.serveData3.x1+1
          }else{
              this.serveData3.x1=0
          }

          if(this.serveData3.x2<=this.serveData3Copy.x2){
          this.serveData3.x2=this.serveData3.x2+1
          }else{
              this.serveData3.x2=0
          }
          if(this.serveData3.x3<=this.serveData3Copy.x3){
          this.serveData3.x3+=1
          }else{
              this.serveData3.x3=0
          }
      }, 3000);
        },
    scroll() {
      this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
      setTimeout(() => {
        //   this.serveData.jdzh+=1
          console.log("dao")
        this.scdtList.push(this.scdtList[0]); // 将数组的第一个元素添加到数组的
        this.scdtList.shift(); //删除数组的第一个元素
        this.animate = false; // margin-top 为0 的时候取消过渡动画，实现无缝滚动
      }, 1000);
    },
    mouseOver() {
      console.log('鼠标悬停')
      // this.animate = false;
      clearInterval(this.timer)
    },
    mouseOut() {
      // this.animate = true;
    //   if (this.scdtList.length > 7) {
        this.timer = setInterval(this.scroll, 2000);

    //   }
      //   this.timer=setInterval(this.scroll, 2000);
    },
    }
}
</script>
<style lang="less" scoped>
.jsc-content{
    height: 100%;
    margin: 0px 30px;
    width: 98%;
    display: flex;
    justify-content: space-between;
    .jscLeft{
        margin-top: 1%;
        width: 23%;

    }
    .jscRight{
        margin-top: 1%;
         width: 23%;
         margin-right: 30px;
    }
}
.line-content{
    margin-top: 5px;
    margin-bottom: 10px;
    display: flex;
    .line1{
    width: 68px;
    height: 2px;
    background-color: rgb(37,109,237);
    margin-right: 2px;
}
.line2{
    width: 128px;
    height: 1px;
    background-color: rgb(89,124,199);
}
}
  .majorEvents-List {
    width: 95%;
    height: 93%;
    overflow: auto;
margin: 10px 0px;
    border: 1px solid rgb(55,55,55);
    border-radius: 5px;
    padding:10px;
  }

  /*滚动条样式*/

  .majorEvents-List::-webkit-scrollbar {
    width: 2px;
    /*height: 4px;*/
  }

  .majorEvents-List::-webkit-scrollbar-thumb {
    border-radius: 20px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.026);
    background: rgba(0, 0, 0, 0.026);
  }

  .majorEvents-List::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.026);
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.016);

  }



  .majorEvents-item {
    display: flex;
    justify-content: space-between;
    padding: 5px;
    // border-bottom: 1px solid #f4f4f4;
    width: 100%;
    cursor: pointer;
    font-size: 12px;
    color: #fff;

  }

  .timeStyle {
    line-height: 22px;
    color: #999;
  }

  .anim {
  transition: all 1s;
  margin-top: -33px;
  padding-bottom: 33px;
}
  .majorEvent-item-title {
    width: 80%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    span {
      color: #fff;
    }
  }
  .itemActive{
      background-color: rgb(8,28,59);
  }
  .majorEvents-item-title{
    position: relative;
    z-index: 999;
    color: #b5b5b5;
    background-color: rgb(8,28,59);
    display: flex;
    justify-content: space-between;
    padding: 5px;
    font-size: 14px;
  }
  .jdzh{
      display: flex;
      margin-bottom: 10px;
  }
  .jdzh-left{
    margin-right: 10px;
    display: flex;
    justify-content: center;
    width: 30%;
    align-items: center;
    font-size: 14px;
  }
  .jdzh-right{
      width: 70%;
      font-size: 12px;
      .jdzh-right-item{
          display: flex;
          justify-content: space-between;
          padding: 5px;
           padding-left: 20px;
          color: rgb(193,78,75);          
      }
      .cq-right-item{
          display: flex;
          justify-content: space-between;
          padding: 5px;
           padding-left: 20px;
          color: rgb(193,78,75);          
      }
      .yh-right-item{
          display: flex;
          justify-content: space-between;
          padding: 5px;
           padding-left: 20px;
          color: rgb(193,78,75);          
      }
        .db-right-item{
          display: flex;
          justify-content: space-between;
          padding: 5px;
           padding-left: 20px;
          color: rgb(156, 219, 236);         
        }
      .jdzh-right-sz{
          margin-right: 20px;
          font-weight: 600;
      }
  }
  .jdzh-right-item{
          background-image: linear-gradient(to right, rgb(70,21,15) , rgb(19,18,28));
  }
    .cq-right-item{
          background-image: linear-gradient(to right, rgb(70,38,15) , rgb(19,22,27));
  }
    .yh-right-item{
          background-image: linear-gradient(to right, rgb(29,10,91) , rgb(5,17,43));
  }
   .db-right-item{
          background-image: linear-gradient(to right, rgb(0,55,75) , rgb(0,28,49));
   }
  .cbfb-content{
      border: 1px solid #373737;
      border-radius: 5px;
      text-align: center;
      img{
          width: 100%;
          height: 140px;
      }
  }
  .zdgcBg{
    //   background-image: url("../../assets/cockpitCh/zdgcBg.png");
        background-repeat: no-repeat;
  background-position: center;
      background-size: 100% 100%;
      height: 190px;
      position: relative;
      .zdgcBgImg{
          position: absolute;
          z-index: 9;
          width: 100%;
          height: 100%;
      }
  }
  .dbBtn{
    // background-color: rgb(7,79,102);
    padding: 5px;
    // cursor: pointer;
    i{
        color:#F3FF25;
    font-size: 16px;
    margin-left: 7px;
            cursor: pointer;
    }
  }
  .jscMiddle{
      width: 53%;
  }
.radioGroupStyle{
    /deep/.el-radio-button__inner{
        background-color: rgb(72,85,116);
        border: 1px solid rgb(72,85,116);
        color: #b5b5b5;
    }
    /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner{
color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
    -webkit-box-shadow: -1px 0 0 0 #409eff;
    box-shadow: -1px 0 0 0 #409eff;
    }
}
</style>
<style lang="less">
    .popperStyle{
      background: rgba(1,13,60,0.1) !important;
      border: 1px solid #12123a !important;
      top: 394px !important;
      padding: 0px;
      line-height: 0.4;
      left: 1128px !important;
  }
.el-popper[x-placement^=top] .popper__arrow{
    border-top-color: #12123a !important;
}
.el-popper[x-placement^=top] .popper__arrow::after{
    border-top-color: #12123a !important;
}
.jscMiddle-topContent{
    display: flex;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/cockpitCh/jsc.vue